import {
    SET_DATA_CASH, ADD_DATA_CASH, UPDATE_DATA_CASH, REMOVE_DATA_CASH,
} from "./actionTypes"

const initialState = {
    cash_items: [],
    resume_cash_items: [],
    session_totals: [],
    items: []
}

// El fondo de caja NO es una venta: es plata que ya estaba en el cajon para dar
// cambio. Mezclarlo con los cobros hacia que ningun numero sirviera — ni para
// saber cuanto se vendio, ni para contar el cajon. Ahora va aparte.
const isFondo = (t) => t === 'init'

// Deteccion de efectivo por el nombre de la forma de pago. Es lo unico
// disponible: la forma de pago no trae un marcador de "es efectivo".
// Si el cliente la renombro a algo que no contenga "efectivo", el arqueo no se
// puede calcular y se omite (mejor no mostrarlo que mostrarlo mal).
const isEfectivo = (fpay) => {
    const n = (fpay || '').toLowerCase()
    return n.includes('efectivo') || n.includes('cash')
}

const Analyze = (items) => {

    if (items.length === 0) {
        return [[], [], []]
    }
    const resumes = []
    const totals = []
    let newItemsCash = []
    let init = 0
    items.forEach(itemCash => {

        if (itemCash.type === 'init') {
            init += 1
        }

        if (init > 0) {
            let index = init - 1
            if (newItemsCash[index] == undefined) {
                newItemsCash[index] = []
            }

            newItemsCash[index].push(itemCash)

            // El desglose por forma de pago se inicializa para TODA sesion,
            // aunque solo tenga el fondo. Antes se creaba recien al encontrar
            // un movimiento que no fuera fondo: una sesion recien abierta no
            // generaba su entrada, `resumes` quedaba MAS CORTO que `totals`, y
            // como la pantalla hace .reverse() sobre los dos, los indices se
            // desalineaban. Resultado: la sesion nueva mostraba el desglose de
            // la anterior — millones en efectivo en una caja que solo tenia el
            // fondo.
            if (resumes[index] === undefined) {
                resumes[index] = []
            }

            // TOTALES DE LA SESION — fondo, cobros y retiros por separado
            if (totals[index] === undefined) {
                totals[index] = {
                    cobrado: 0,          // NETO: cobros menos anulaciones y devoluciones
                    cobradoBruto: 0,     // solo los cobros, sin descontar nada
                    fondo: 0,            // lo que habia al abrir
                    retiros: 0,          // anulaciones y devoluciones (en positivo)
                    efectivoCobrado: 0,
                    retirosEfectivo: 0,
                    tieneEfectivo: false, // si no, no se puede calcular el arqueo
                }
            }
            const t = totals[index]
            const v = itemCash.value || 0
            const efectivo = isEfectivo(itemCash.fpay)
            if (efectivo) t.tieneEfectivo = true

            if (isFondo(itemCash.type)) {
                t.fondo += v
            } else {
                // El cobrado es NETO. Una anulacion no es "cobre y devolvi":
                // es un cobro que nunca debio existir. Si no se netea, cobrar y
                // anular 10 veces por error mostraria "cobrado 10.000 /
                // devuelto 10.000" como si hubiera pasado algo. Ademas asi
                // coincide con el desglose del ticket de cierre, que es neto.
                t.cobrado += v
                if (v > 0) {
                    t.cobradoBruto += v
                    if (efectivo) t.efectivoCobrado += v
                } else {
                    t.retiros += Math.abs(v)
                    if (efectivo) t.retirosEfectivo += Math.abs(v)
                }
            }

            // RESUMES por forma de pago — NETO por medio (excluye solo el
            // fondo). Suma exactamente el "cobrado" de arriba, que tambien es
            // neto: si se anula un cobro con tarjeta, baja la fila de tarjeta.
            //
            // Un movimiento sin forma de pago va a "Sin forma de pago" en vez
            // de omitirse: si se omitiera, el desglose dejaria de sumar el
            // total y la plata desapareceria de la vista sin dejar rastro.
            if (!isFondo(itemCash.type)) {
                const nombre = (itemCash.fpay != undefined && itemCash.fpay != null
                    && String(itemCash.fpay).trim() !== '')
                    ? itemCash.fpay
                    : 'Sin forma de pago';

                const fpayObj = resumes[index].find(obj => obj.name === nombre);
                if (fpayObj === undefined) {
                    resumes[index].push({ name: nombre, value: v });
                } else {
                    fpayObj.value += v;
                }
            }

        }
    })

    // Efectivo que deberia haber en el cajon:
    //   fondo + cobrado en efectivo - retirado en efectivo
    // NO es "cobrado + fondo": la tarjeta y MercadoPago no estan en el cajon.
    totals.forEach((t) => {
        if (!t) return
        t.efectivoEnCaja = t.fondo + t.efectivoCobrado - t.retirosEfectivo
    })



    // Calculate percent for each element in resumes
    resumes.forEach((resumesArr) => {
        const total = resumesArr.reduce((sum, itemResume) => sum + itemResume.value, 0);
        resumesArr.forEach((itemResume) => {
            // Si el neto de la sesion da 0 (todo anulado), la division daria
            // NaN y la pantalla mostraria "NaN%".
            itemResume.percent = total !== 0 ? (itemResume.value / total) * 100 : 0;
        });
    });

    // Agregar elemento 'Total' al inicio de cada array
    resumes.forEach(array => {
        const totalValue = array.reduce((sum, itemResume2) => sum + itemResume2.value, 0);
        array.unshift({ name: 'Total', value: totalValue, percent: 100 });
    });


    return [newItemsCash, resumes, totals]

}

const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DATA_CASH:

            const items = action.payload

            const [newItemsCash, resumes, totals] = Analyze(items)

            return {
                ...state,
                items: action.payload,
                cash_items: [...newItemsCash],
                resume_cash_items: [...resumes],
                session_totals: [...totals],
            }


        case ADD_DATA_CASH:

            const newItems2 = [...state.items, action.payload]
            const [new_cash_items, resumes2, totals2 ] = Analyze(newItems2)

            return {
                ...state,
                items: newItems2,
                cash_items: new_cash_items,
                resume_cash_items: resumes2,
                session_totals: totals2,
            }

        // Un movimiento que CAMBIO. Pasa cuando se le corrige la forma de pago
        // desde la caja del Desktop: el documento se modifica en el lugar, no
        // se crea uno nuevo.
        //
        // Se reemplaza EN SU POSICION, no se agrega al final: `Analyze` recorre
        // los items en orden y va cortando sesiones en cada 'init', asi que
        // moverlo de lugar lo pasaria a otra sesion. Y si el movimiento no esta
        // en la lista —quedo fuera de la ventana cargada— no se agrega: la
        // ventana la decide la consulta, no un cambio suelto.
        case UPDATE_DATA_CASH: {
            const cambiado = action.payload
            let encontrado = false
            const actualizados = state.items.map((it) => {
                if (String(it.id) === String(cambiado.id)) {
                    encontrado = true
                    return cambiado
                }
                return it
            })
            if (!encontrado) return state

            const [ci3, r3, t3] = Analyze(actualizados)
            return {
                ...state,
                items: actualizados,
                cash_items: ci3,
                resume_cash_items: r3,
                session_totals: t3,
            }
        }

        case REMOVE_DATA_CASH: {
            const quitado = action.payload
            const restantes = state.items.filter(
                (it) => String(it.id) !== String(quitado.id))
            if (restantes.length === state.items.length) return state

            const [ci4, r4, t4] = Analyze(restantes)
            return {
                ...state,
                items: restantes,
                cash_items: ci4,
                resume_cash_items: r4,
                session_totals: t4,
            }
        }

        default:
            return state
    }
}

export default dataReducer
